import React, { useMemo } from 'react';
import DataGrid from '../../common/DataGrid';

/**
 * Supplier grid — column definitions only.
 * Before: 104 lines.  After: ~25 lines.
 */
export default function SupplierGrid(props) {
  const columns = useMemo(
    () => [
      { field: 'supplier_id', headerName: 'ID', maxWidth: 100, flex: 0 },
      { field: 'supplier_name', headerName: 'Supplier Name', minWidth: 150 },
      { field: 'contact_name', headerName: 'Contact Person', minWidth: 150 },
      { field: 'contact_number', headerName: 'Phone', minWidth: 120 },
      { field: 'email', headerName: 'Email', minWidth: 200 },
    ],
    []
  );

  return (
    <DataGrid
      {...props}
      columns={columns}
      exportFileName="supplier_data.csv"
    />
  );
}
